import { render, staticRenderFns } from "./VmStudentInfo.vue?vue&type=template&id=33d85ca0&scoped=true&"
import script from "./VmStudentInfo.vue?vue&type=script&lang=js&"
export * from "./VmStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./VmStudentInfo.vue?vue&type=style&index=0&id=33d85ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d85ca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
